export default {
  en: {
    configureTitle: 'Configure SSO',
    configureDesc:
      'SSO enables your users to login to Risk Ledger through an identity provider of your choice.',
    addDomainsTitle: 'Add domains',
    addDomainsTooltip: 'Specify the email domain(s) used by your team.',
    addDomainsInput: 'example1.com, example2.com',
    setup: 'Continue setup',
    manage: 'Manage',
    invalid: 'Please enter a valid domain e.g. example.com',
    error: 'Failed to setup SSO. Please try again.',
    manage_error: 'Failed to get connection details. Please try again.',
    status_error: 'Failed getting SSO status. Please try again.',
    enforceSSO: 'Enforce SSO',
    enforceSSODesc:
      'When enabled, your users can only sign in using SSO.<br />Lead and Admin users may still sign in with their password.',
    enforceSSOFail: 'Failed to update setting. Please try again.',
    setupSSO: 'Setup SSO',
    configuredConnections: 'Configured SAML SSO connections',
    connectionCard: {
      manageHelp: 'If you would like to modify your SSO configuration, contact support for help.',
      identityProvider: 'Identity provider',
      state: 'Status',
      createdAt: 'Created at',
      connectedDomains: 'Connected domain | Connected domains',
    },
    userProvisioning: 'User provisioning',
    userProvisioningDesc:
      'If enabled, user accounts will be created automatically for new users signing in to the platform with SSO.<br />Select the default role for new users below.',
    userProvisioningFail: 'Failed to update setting. Please try again.',
    userProvisioningRoleRequiredFail: 'Please select a default role for new users.',
    roleOptions: {
      admin: 'Admin',
      edit: 'Edit',
      view: 'View',
    },
    retry: 'Retry',
    defaultRole: 'Default role',
    signInWithGoogle: 'Sign in with Google',
    signInWithGoogleDesc: 'If enabled, user accounts will be able to sign in with Google',
    signInWithGoogleFail: 'Failed to update Google sign-in setting. Please try again.',
  },
};
